import script from "./card-empresa.vue?vue&type=script&setup=true&lang=js"
export * from "./card-empresa.vue?vue&type=script&setup=true&lang=js"

import "./card-empresa.vue?vue&type=style&index=0&id=388c3326&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-388c3326"]])

export default __exports__